import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace DocumentViewFields {
  export enum DocumentViewFieldsConfigFields {
    MassCodingFields = 'MassCodingFields.Fields',
  }
}

class DocumentViewFieldsConfig extends SettingsSubModule {
  @SettingsSubModule.value(DocumentViewFields.DocumentViewFieldsConfigFields.MassCodingFields, '')
  massCodingFields: SettingValue<string>;
}

export class DocumentViewModule extends SettingsModule {
  @SettingsModule.value(DocumentViewFieldsConfig) documentViewFields: DocumentViewFieldsConfig;
}
